import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MultiLanguageManagementService } from '../multi-language-management.service';
import { Page } from 'src/app/shared/models/paging/page';
import { PrimasTableComponent } from 'src/app/shared/components/template-management/primas-table/primas-table.component';
import { permissionMultiLanguage } from 'src/app/shared/contances/permission';
import { PrimasToolbarComponent } from 'src/app/shared/components/template-management/primas-toolbar/primas-toolbar.component';
import { PrimasFilterType } from 'src/app/shared/enums/primas-value-type.enum';
import { AddEditTranslateComponent } from './add-edit-translate/add-edit-translate.component';
import { TblActionType } from 'src/app/shared/enums/tbl-action-type.enum';
import { ProfileType } from '../../opportunity-management/opportunity-details/opportunity-details.component';
import { EntityTranslate } from '../multi-language.model';
import { NbToastrService } from '@nebular/theme';
import { RemoveAtionIdList } from '../../profile-management/profile-detail.model';
import { SettingService } from '../../../../shared/services/setting.service';

@Component({
  selector: 'app-translate-center-dialog',
  templateUrl: './translate-center-dialog.component.html',
  styleUrls: ['./translate-center-dialog.component.scss'],
})
export class TranslateCenterDialogComponent implements OnInit {
  @ViewChild('primasToolbar', { static: true }) primasToolbar: PrimasToolbarComponent;
  @ViewChild('primasTable', { static: true }) primasTable: PrimasTableComponent;
  @ViewChild('dateTimeCreated', { static: true }) dateTimeCreatedTemplate: TemplateRef<any>;
  @ViewChild('dateTimeModified', { static: true }) dateTimeModifiedTemplate: TemplateRef<any>;
  @ViewChild('leftBlogDescription', { static: true }) leftBlogDescriptionTemplate: TemplateRef<any>;
  @ViewChild('rightBlogDescription', { static: true }) rightBlogDescriptionTemplate: TemplateRef<any>;
  @ViewChild('askAnExpertDescription', { static: true }) askAnExpertDescriptionTemplate: TemplateRef<any>;
  @ViewChild('publish', { static: true }) publishTemplate: TemplateRef<any>;
  @ViewChild('language', {static: true}) languageTemplate: TemplateRef<any>;
  @ViewChild('bookingHighlight', { static: true }) bookingHighlightTemplate: TemplateRef<any>;
  @ViewChild('bios', { static: true }) biosTemplate: TemplateRef<any>;
  @ViewChild('previousClient', { static: true }) previousClientTemplate: TemplateRef<any>;
  @ViewChild('testomonial', { static: true }) testomonialTemplate: TemplateRef<any>;
  @ViewChild('togglePublish', {static: true}) publishCustomAction: TemplateRef<any>;

  @Input() maxHeight: string = '45vh';

  addEditComponent = AddEditTranslateComponent;
  permission = JSON.parse(JSON.stringify(permissionMultiLanguage));
  addNewAdditionalData: {model: Record<string, string | number>} = null;
  updateAdditionalData: {addtionalData: Record<string, string | number>} = null;

  listLanguages: any[];
  settingListLanguages: any[];
  isLoadingLanguages = true;
  columns: any[] = [];
  referenceType: string;
  referenceRevisionId: number;
  referenceId: string;
  listDatas: any[];
  displayFullLanguage: boolean = false;

  // 2nd layer data (layer1[x])
  overrideRefType: string = null;
  overrideRefId: string = null;

  constructor(
    private multiLanguageService: MultiLanguageManagementService,
    public dialogRef: MatDialogRef<TranslateCenterDialogComponent>,
    private toast: NbToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private settingService: SettingService
  ) { 
    //This is for fetching the translation that is belong to it
    this.referenceType = data?.referenceType ?? this.referenceType
    this.referenceId = data?.referenceId ?? this.referenceId
    this.referenceRevisionId = data?.referenceRevisionId ?? this.referenceRevisionId
    this.overrideRefType = data?.overrideRefType ?? this.overrideRefType
    this.overrideRefId = data?.overrideRefId ?? this.overrideRefId

    //We need to do this because later, when we add new by primasToolBar, it will pass this into the Add Edit Component
    this.addNewAdditionalData = {
      model: {
        objName: this.referenceType,
        objId: this.referenceId,
        revisionId: this.referenceRevisionId,
        overrideRefType: this.overrideRefType,
        overrideRefId: this.finalRefType === 'CategoryLocation' ? this.overrideRefId : null,
      }
    }
    this.updateAdditionalData = {
      addtionalData: {
        revisionId: this.referenceRevisionId
      }
    }
    this.loadLanguages();
  }

  async ngOnInit() {
    this.columns = [
      {
        name: 'Language',
        prop: 'lang',
        filter: true,
        cellTemplate: this.languageTemplate
      },
      {
        name: "Publish",
        prop: "isPublish",
        filter: {
            filterType: PrimasFilterType.Boolean,
            filterValue: [
              {
                text: 'True',
                value: true
              },
              {
                text: 'False',
                value: false
              }
            ],
            displayText: 'text',
            displayValue: 'value'
        },         
        cellTemplate: this.publishTemplate
      },
      {
        name: this.formatReferenceType === EntityTranslate.Profile ? 'ProfileId' : this.formatReferenceType === EntityTranslate.Location ? 'LocationId' : this.formatReferenceType === EntityTranslate.Category ? 'CategoryId' : 'ReferenceId',
        prop: 'objId',
        filter: true,
      },
      {
        name: 'Friendly URL',
        prop: 'friendlyUrl',
        filter: true,
      },
      {
        name: 'Seo Title',
        prop: 'seoTitle',
        filter: true,
      },
      {
        name: 'Seo Description',
        prop: 'seoDescription',
        filter: true,
      },
    ]
    this.appendColumns();
    this.primasTable.page.pageNumber = 0;
  }
  
  async loadLanguages() {
    this.isLoadingLanguages = true;
    try {
      //Load All Language For Displaying
      this.listLanguages = await this.multiLanguageService.getLanguage().toPromise();
      //Load Setting Language For Comparing Function
      const data = await this.settingService.getSettingByKeyAndGroup('TRANSLATION_LANGUAGES', 'MULTI_LANGUAGE').toPromise();

      if (data?.result?.value) {
        try {
          this.settingListLanguages = JSON.parse(data.result.value);
        } catch (err) {
          console.warn("Failed to parse setting value, will fallback in finally");
        }
      } 
    } catch (err) {
      console.error("Error fetching translation settings:", err);
    }
    finally {
      if (!this.settingListLanguages) this.settingListLanguages = this.listLanguages;
      this.isLoadingLanguages = false;
      this.compareLanguage();
    }
  }

  refreshData(reset: boolean = false): void {
    this.primasTable.isLoading = 1;
    this.permission.toolbar.add = this.permission.toolbar.add + ('(turnoff)');
    if (reset) {
      this.primasTable.page.pageNumber = 0;
      this.primasTable.cache = {};
      this.primasTable.rows = [];
      this.primasTable.selected = [];
      this.primasTable.table.offset = 0;
      this.primasTable.table.bodyComponent.offsetY = 0;
    }

    this.multiLanguageService
      .getWpLangContentsByIdAndReferenceType(
        this.primasTable.page,
        this.finalRefId,
        this.finalRefType
      )
      .subscribe({
        next: (e) => {
          if(e.result)
          {
            this.primasTable.setData(e.result);
            this.listDatas = e.result?.data;
            this.compareLanguage();
          }          
        },
        error: (err) => {
          console.error("Fetch error:", err);
        },
        complete: () => {
          // always runs after success or error
          this.primasTable.isLoading = 0;
        }
      });

  }

  appendColumns() {
    switch(this.referenceType?.toUpperCase())
    {
      case 'LOCATION': {
        this.columns = [...this.columns, 
          {
            name: 'First Content',
            prop: 'topDescription',
            filter: true,
          },
          {
            name: 'Second Content',
            prop: 'description',
            filter: true
          }
        ]
        break;
      }
      case 'CATEGORY': {
          if (this.finalRefType === 'CategoryLocation') {
            this.columns = [...this.columns,
              {
                name: 'Top Description',
                prop: 'topDescription',
                filter: true,
              },
              {
                name: 'Description',
                prop: 'description',
                filter: true
              },
            ]
          }
          else {
            this.columns = [...this.columns,
            {
              name: 'Top Description',
              prop: 'topDescription',
              filter: true,
            },
            {
              name: 'Description',
              prop: 'description',
              filter: true
            },
            {
              name: 'Left Blog Description',
              prop: 'extendData',
              sortable: false,
              filter: false,
              cellTemplate: this.leftBlogDescriptionTemplate
            },
            {
              name: 'Right Blog Description',
              prop: 'extendData',
              sortable: false,
              filter: false,
              cellTemplate: this.rightBlogDescriptionTemplate,
            },     
            {
              name: 'Ask An Expert Description',
              prop: 'extendData',
              sortable: false,
              filter: false,
              cellTemplate: this.askAnExpertDescriptionTemplate
            }  
          ]
        }
        break;
      }
      case 'PROFILE':{
        this.columns = [...this.columns,
        {
          name: 'H1',
          prop: 'title',
          filter: true,
        },
        {
          name: 'Booking Highlight',
          prop: 'reasons',
          filter: false,
          sortable: false,
          cellTemplate: this.bookingHighlightTemplate
        },
        {
          name: 'Description',
          prop: 'bios',
          filter: true,
          ellTemplate: this.biosTemplate
        },
        {
          name: 'Previous Client',
          prop: 'previousClient',
          filter: false,
          sortable: false,
          cellTemplate: this.previousClientTemplate
        },
        {
          name: 'Testomonial',
          prop: 'extendData',
          filter: false,
          sortable: false,
          cellTemplate: this.testomonialTemplate
        }
        ]
        break;
      }

    }

    // Date Column
    this.columns = [...this.columns, 
      {
        name: 'Date Created',
        prop: 'dateCreated',
        filter: {
          filterType: PrimasFilterType.Date
        },
        headerClass: 'filter-date-time-column',
        cellTemplate: this.dateTimeCreatedTemplate
      },
      {
        name: 'Date Modified',
        prop: 'dateModified',
        filter: {
          filterType: PrimasFilterType.Date
        },
        headerClass: 'filter-date-time-column',
        cellTemplate: this.dateTimeModifiedTemplate
      },
    ]
  }

  onCloseClick() 
  {
    this.dialogRef.close();
  }

  async onTogglePublish(row: any) 
  {
    const textToDisplay = row?.isPublish ? "Unpublish translation successfully!" : "Publish translation successfully!";
    row.isPublish = !row.isPublish;
    const resp = await this.multiLanguageService.saveTranslation(row).toPromise();
    if (resp?.result)
    {
      this.toast.success(textToDisplay, 'Success');
      this.refreshData(false);
    }
  }

  get formatReferenceType(): string {
    if (!this.referenceType) return "";
    return this.referenceType.charAt(0).toUpperCase() + this.referenceType.slice(1).toLowerCase();
  }
  
  async onClickDelete(data: any) {   
    try {
      this.primasTable.isLoading = 1;

      const resp = await this.multiLanguageService.deleteTranslation(data?.row?.langContentId).toPromise();
      if (resp?.result) {
        this.toast.success(
          `Delete translation successfully!`,
          "Success"
        );
        this.refreshData();
      }
    } 
    catch (error) {
      console.error(error);
    } 
    finally {
      this.primasTable.isLoading = 0;
    }
  }
  
  async onDeletes() {
    try {
      this.primasTable.isLoading = 1;
      var model: RemoveAtionIdList = new RemoveAtionIdList();
      model.idList = this.primasTable.selected.map((x) => x.langContentId);
      
      const resp = await this.multiLanguageService.deleteMultipleTranslation(model).toPromise();
      if (resp?.result) {
        this.toast.success(
          `Delete ${model.idList.length} translation successfully!`,
          "Success"
        );
        this.refreshData(true);
      }
    }
    catch (error) {
      console.error(error);
    }
    finally {
      this.primasTable.isLoading = 0;
    }
  }

  compareLanguage(): void {
    // Ensure data and languages exist because we will have race conditions where listDatas complete first and listLanguages not vice versa
    if (!this.settingListLanguages || this.settingListLanguages.length === 0) {
      return;
    }

    // If no data but has language, enable add button
    if (!this.listDatas || this.listDatas.length === 0) {
      this.permission.toolbar = {...permissionMultiLanguage.toolbar}
      return;
    }

    // Collect translated language codes
    const translatedCodes = new Set(this.listDatas.map(item => item.lang));

    // Find missing languages
    const missingLanguages = Object.keys(this.settingListLanguages).filter(
      code => !translatedCodes.has(code)
    );

    // Disable button if nothing is missing
    if(missingLanguages.length === 0) {
      this.displayFullLanguage = true
    } else {
      this.displayFullLanguage = false
      this.permission.toolbar = { ...permissionMultiLanguage.toolbar }
    }
  }

  get finalRefType(): string {
    return this.overrideRefType ? this.overrideRefType : this.referenceType;
  }

  get finalRefId(): string {
    return this.overrideRefId ? this.overrideRefId : this.referenceId;
  }
}

